<template>
  <div class="admin-popup" @click.self.stop="$emit('close')">
    <div class="admin-popup__contents">
      <slot></slot>
    </div>
  </div>
</template>
